<template>
  <div v-if="trimmedText" class="jb-report-watermark">
    <div class="jb-report-watermark-inner" :style="innerStyle">
      <span
        v-for="idx in tileIndices"
        :key="'wm-' + idx"
        class="jb-report-watermark-item"
      >{{ displayText }}</span>
    </div>
  </div>
</template>

<script>
/**
 * 鉴别报告卡片斜向平铺水印（鉴别编号），铺满父级 .report-card（需 position:relative + overflow:hidden）
 */
export default {
  name: "JbReportWatermark",
  props: {
    /** 水印文案，通常与样品信息「鉴别编号」一致；空则不渲染 */
    text: {
      type: String,
      default: "",
    },
    /** 平铺重复段数量（默认 192 = 6 列 × 32 行） */
    tileCount: {
      type: Number,
      default: 192,
    },
    /** 网格列数（默认 6 列） */
    columns: {
      type: Number,
      default: 6,
    },
    /**
     * 水印层在垂直居中基础上的上移量（rpx），0 为严格居中。
     * 一般无需调整；仅当整页仍偏下时可略设（如 56）。
     */
    offsetYRpx: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    trimmedText() {
      const t = this.text;
      if (t == null || String(t).trim() === "") return "";
      return String(t).trim();
    },
    /** 平铺展示文案，前缀与样品信息栏「鉴别编号：」一致 */
    displayText() {
      const t = this.trimmedText;
      if (!t) return "";
      return `鉴别编号：${t}`;
    },
    tileIndices() {
      const n = Math.max(0, Number(this.tileCount) || 192);
      return Array.from({ length: n }, (_, i) => i);
    },
    gridRows() {
      const cols = Math.max(1, Number(this.columns) || 6);
      return Math.max(1, Math.ceil(this.tileIndices.length / cols));
    },
    innerStyle() {
      const cols = Math.max(1, Number(this.columns) || 6);
      const y = Number(this.offsetYRpx) || 0;
      const translateY = y <= 0 ? "-50%" : `calc(-50% - ${y / 2}px)`;
      return {
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gridTemplateRows: `repeat(${this.gridRows}, 1fr)`,
        transform: `translate(-50%, ${translateY}) rotate(-33deg)`,
      };
    },
  },
};
</script>

<style scoped>
.jb-report-watermark {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  min-height: 100%;
  z-index: 10;
  pointer-events: none;
  overflow: hidden;
  transform: translateZ(0);
}

.jb-report-watermark-inner {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 280%;
  height: 280%;
  display: grid;
  justify-items: center;
  align-items: center;
  transform-origin: center center;
  row-gap: 28px;
  column-gap: 38px;
  box-sizing: border-box;
}

.jb-report-watermark-item {
  font-size: 11px;
  color: rgba(100, 100, 100, 0.22);
  line-height: 1.2;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/jbReport/JbReportWatermark.vue